import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Banner.css';

const Banner = () => {
  // Banner 动画 variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  const metricsVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        staggerChildren: 0.1
      }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, x: 30 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.6 }
    }
  };

  return (
    <motion.section
      className="hero"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <div className="hero-background">
        <div className="hero-gradient hero-gradient-1" />
        <div className="hero-gradient hero-gradient-2" />
        <div className="hero-lines" />
      </div>

      <div className="container hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <motion.span
              className="hero-tag"
              variants={itemVariants}
            >
              工程造价咨询甲级 · 招标代理甲级资质
            </motion.span>
            <motion.h1 variants={itemVariants}>
              识道造价事务所
              <span className="highlight">工程造价全过程专业服务</span>
            </motion.h1>
            <motion.p variants={itemVariants}>
              立足宁波，服务长三角及全国。深耕工程造价咨询15年，拥有38名注册造价工程师、12名高级工程师。<br />
              为政府、央国企、上市公司提供投资估算、概预算编制审核、结算审核、招投标代理等全生命周期造价咨询服务。<br />
              <strong>配备AI智能审核引擎，审核效率提升85%，准确率达98.6%</strong>
            </motion.p>
            <motion.div
              className="hero-actions"
              variants={itemVariants}
            >
              <Link to="/contact" className="btn btn-primary">预约造价专家</Link>
              <Link to="/services" className="btn btn-secondary">查看全部服务</Link>
            </motion.div>
            <motion.div
              className="hero-metrics"
              variants={metricsVariants}
            >
              <motion.div className="metric-item">
                <strong>15年</strong>
                <span>造价咨询经验</span>
              </motion.div>
              <div className="metric-divider" />
              <motion.div className="metric-item">
                <strong>1200+</strong>
                <span>项目实战案例</span>
              </motion.div>
              <div className="metric-divider" />
              <motion.div className="metric-item">
                <strong>500亿+</strong>
                <span>累计服务金额</span>
              </motion.div>
            </motion.div>
          </div>

          <motion.div
            className="hero-visual"
            variants={cardVariants}
          >
            <div className="hero-card">
              <div className="hero-card-header">
                <span className="hero-card-title">专业造价服务实力</span>
                <span className="hero-card-badge">甲级资质</span>
              </div>
              <div className="hero-card-progress">
                <div className="progress-item">
                  <div className="progress-info">
                    <span>注册造价工程师</span>
                    <span className="progress-value">38名</span>
                  </div>
                  <div className="progress-bar">
                    <span style={{ width: '95%' }} />
                  </div>
                </div>
                <div className="progress-item">
                  <div className="progress-info">
                    <span>项目覆盖率</span>
                    <span className="progress-value">100%</span>
                  </div>
                  <div className="progress-bar">
                    <span style={{ width: '100%' }} />
                  </div>
                </div>
                <div className="progress-item">
                  <div className="progress-info">
                    <span>客户续约率</span>
                    <span className="progress-value">92%</span>
                  </div>
                  <div className="progress-bar">
                    <span style={{ width: '92%' }} />
                  </div>
                </div>
              </div>

              <div className="hero-card-footer">
                <div>
                  <strong>传统经验 + AI增效</strong>
                  <span>资深造价师把关质量，AI工具提升效率</span>
                </div>
                <Link to="/services">查看全部服务 →</Link>
              </div>
            </div>

            <div className="hero-badges">
              <div className="badge">
                <span>工程造价咨询甲级</span>
              </div>
              <div className="badge">
                <span>招标代理甲级</span>
              </div>
              <div className="badge">
                <span>ISO9001质量认证</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
};

export default Banner;